module.exports = __webpack_public_path__ + "static/img/35.a10b51b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/35.png
// module id = SeRG
// module chunks = 1